import type {
  ReactionAggregateResultDTO,
  ReactionResultDTO,
} from '@nora-monorepo/nora-api-client';

export function aggregateReactions(
  reactions: readonly Pick<ReactionResultDTO, 'reaction'>[],
): ReactionAggregateResultDTO[] {
  const counts = new Map<string, number>();
  for (const { reaction } of reactions) {
    counts.set(reaction, (counts.get(reaction) ?? 0) + 1);
  }
  return Array.from(counts, ([reaction, count]) => ({ reaction, count }));
}
